import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Sun } from '../components/Icons';

export default function Login() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr]   = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async e => {
    e.preventDefault(); setErr(''); setBusy(true);
    try {
      const user = await login(email, password);
      if (user.must_change_password) navigate('/change-password');
      else if (user.role === 'field') navigate('/field-portal');
      else navigate('/dashboard');
    } catch (ex) {
      const d = ex.response?.data?.detail;
      setErr(Array.isArray(d) ? d.map(x=>x.msg).join(', ') : (d || 'Invalid email or password.'));
    } finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)', fontFamily:'Inter,sans-serif' }}>
      <div style={{ width:'100%', maxWidth:400 }}>
        {/* Brand */}
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ width:56, height:56, background:'var(--navy)', borderRadius:14, display:'inline-flex', alignItems:'center', justifyContent:'center', marginBottom:16, boxShadow:'0 4px 12px rgba(26,39,68,.3)' }}>
            <Sun s={26} color="#fff"/>
          </div>
          <div style={{ fontSize:22, fontWeight:700, color:'var(--text)', marginBottom:4 }}>Sakthi Solar Solutions</div>
          <div style={{ fontSize:13, color:'var(--text2)' }}>Sign in to your ERP account</div>
        </div>

        {/* Card */}
        <div style={{ background:'var(--white)', border:'1px solid var(--border)', borderRadius:16, padding:32, boxShadow:'var(--shadow-md)' }}>
          {err && (
            <div className="notice n-err" style={{ marginBottom:16 }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              <div>{err}</div>
            </div>
          )}
          <form onSubmit={submit}>
            <div className="fg" style={{ marginBottom:14 }}>
              <label>Email address</label>
              <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required placeholder="your@email.com" autoFocus/>
            </div>
            <div className="fg" style={{ marginBottom:22 }}>
              <label>Password</label>
              <input type="password" value={password} onChange={e=>setPassword(e.target.value)} required placeholder="••••••••"/>
            </div>
            <button type="submit" className="btn btn-primary" style={{ width:'100%', justifyContent:'center', padding:'11px 0', fontSize:14 }} disabled={busy}>
              {busy ? 'Signing in…' : 'Sign In'}
            </button>
          </form>
        </div>

        <div style={{ textAlign:'center', marginTop:16, fontSize:11, color:'var(--text3)' }}>
          Sakthi Solar Solutions ERP &nbsp;|&nbsp; Powered by DSI
        </div>
      </div>
    </div>
  );
}
